import { Link } from "react-router-dom";
import { categories, articles } from "@/mocks/news";

export default function CategoryStrip() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-8 md:py-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {categories.map((category, index) => {
          const count = articles.filter((item) => item.category === category.slug).length;
          const isAccent = index === 1;
          return (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className={`group rounded-lg p-5 border transition-colors cursor-pointer ${
                isAccent
                  ? "bg-accent-100 border-accent-200 hover:border-accent-400"
                  : "bg-background-100 border-background-200 hover:border-primary-300"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`w-11 h-11 rounded-lg flex items-center justify-center text-xl ${
                    isAccent
                      ? "bg-accent-500 text-foreground-950"
                      : "bg-primary-500 text-background-50"
                  }`}
                >
                  <i className={category.icon}></i>
                </span>
                <span className="text-xs text-foreground-500 font-label">{count} 篇快讯</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {category.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2 font-label">
                {category.desc}
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}